/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolVolunteerActivismIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-volunteer-activism"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M13.25 22.85Q13.68 22.98 14.04 22.96Q14.4 22.95 14.75 22.82L22.8 20.3Q22.8 18.6 22.01 17.7Q21.23 16.8 19.52 16.8L14 16.8Q13.28 16.8 12.82 16.76Q12.38 16.73 11.95 16.55L10.43 15.93Q10.15 15.8 10.05 15.57Q9.95 15.35 10.05 15.07Q10.15 14.8 10.39 14.66Q10.63 14.53 10.9 14.63L12.03 15Q12.6 15.2 13.15 15.28Q13.7 15.35 14.28 15.35L16.55 15.35Q16.95 15.35 17.2 15.1Q17.45 14.85 17.45 14.45Q17.45 13.9 16.98 13.26Q16.5 12.63 15.4 12.2L9.45 9.97Q9.2 9.88 8.96 9.84Q8.72 9.8 8.53 9.8L6.6 9.8L6.6 21.05ZM0 20.45Q0 21.43 0.68 22.11Q1.35 22.8 2.33 22.8L2.33 22.8Q3.27 22.8 3.94 22.1Q4.6 21.4 4.6 20.45L4.6 12.15Q4.6 11.2 3.94 10.5Q3.27 9.8 2.33 9.8L2.33 9.8Q1.35 9.8 0.68 10.49Q0 11.18 0 12.15ZM16.15 10.5Q16.15 10.5 15.91 10.5Q15.68 10.5 15.21 10.34Q14.75 10.18 14.38 9.82L11.65 7.38Q10.8 6.63 10.2 5.67Q9.6 4.72 9.6 3.6Q9.6 2.08 10.71 1.04Q11.82 0 13.4 0Q14.18 0 14.89 0.3Q15.6 0.6 16.15 1.15Q16.73 0.57 17.44 0.29Q18.15 0 18.95 0Q20.5 0 21.6 1.04Q22.7 2.08 22.7 3.6Q22.7 4.72 22.1 5.67Q21.5 6.63 20.65 7.38L17.93 9.82Q17.55 10.18 17.09 10.34Q16.63 10.5 16.15 10.5Z" fill={color} />
    </svg>
  );
}
